/* DAO badge order, 2026-10-20: existing novelty first, then rendered width. */
(function () {
  'use strict';
  if (window.__daoProductBadgeOrderLoaded) return;
  window.__daoProductBadgeOrderLoaded = true;

  var selector = '.product-label-container';
  var framePending = false;

  function sortGroups() {
    framePending = false;
    var plans = [];
    document.querySelectorAll(selector).forEach(function (group) {
      var labels = Array.from(group.children).filter(function (element) {
        return element.matches('.product-label');
      });
      if (labels.length < 2) return;
      var entries = labels.map(function (element, index) {
        return {
          element: element,
          index: index,
          novelty: element.classList.contains('product-label--new-in'),
          width: element.getBoundingClientRect().width
        };
      });
      if (!entries.some(function (entry) { return entry.width > 0; })) return;
      entries.sort(function (left, right) {
        if (left.novelty !== right.novelty) return left.novelty ? -1 : 1;
        return left.width - right.width || left.index - right.index;
      });
      plans.push({ group: group, original: labels, ordered: entries });
    });

    // Read all widths before changing any group to avoid repeated forced layouts.
    plans.forEach(function (plan) {
      var moved = plan.ordered.some(function (entry, index) {
        return entry.element !== plan.original[index];
      });
      if (moved) {
        plan.ordered.forEach(function (entry) {
          plan.group.appendChild(entry.element);
        });
      }
      // Inline order also supersedes older product-specific flex order overrides.
      plan.ordered.forEach(function (entry, index) {
        var order = String(index);
        if (entry.element.style.order !== order) entry.element.style.order = order;
      });
    });
  }

  function scheduleSort() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(sortGroups);
  }

  function containsGroup(node) {
    return node.nodeType === 1 &&
      (node.matches(selector) || Boolean(node.querySelector(selector)));
  }

  function boot() {
    var observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        var target = record.target.nodeType === 1 ?
          record.target : record.target.parentElement;
        if (target && target.closest(selector)) return true;
        return Array.from(record.addedNodes).some(containsGroup);
      });
      if (relevant) scheduleSort();
    });
    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
    window.addEventListener('resize', scheduleSort, { passive: true });
    // Covers already-rendered quick views becoming visible without new markup.
    document.addEventListener('click', scheduleSort, { capture: true, passive: true });
    document.addEventListener('change', scheduleSort, { capture: true, passive: true });
    document.addEventListener('shopify:section:load', scheduleSort);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleSort);
    }
    scheduleSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());
